import React from 'react';
import PropTypes from 'prop-types';
import {
  useEligibilityProducts,
  useEligibilityActions,
  useHasUnsavedChanges,
  useEligibilityTheme,
} from '../hooks/useEligibilityEngine';
import ProductSelector from './ProductSelector';

const EligibilityProductSelector = ({ tooltipContent, placeholderText }) => {
  const { products, selectedProduct } = useEligibilityProducts();
  const { onProductChange } = useEligibilityActions();
  const hasUnsavedChanges = useHasUnsavedChanges();
  const { themeClass } = useEligibilityTheme();

  return (
    <ProductSelector
      products={products}
      selectedProduct={selectedProduct}
      onProductChange={onProductChange}
      hasUnsavedChanges={hasUnsavedChanges}
      tooltipContent={tooltipContent}
      placeholderText={placeholderText}
      themeClass={themeClass}
    />
  );
};

EligibilityProductSelector.propTypes = {
  tooltipContent: PropTypes.string,
  placeholderText: PropTypes.string,
};

EligibilityProductSelector.defaultProps = {
  tooltipContent: 'Select the product to edit eligibility rules.',
  placeholderText: 'SELECT PRODUCT CONTEXT',
};

export default EligibilityProductSelector;
